import React from 'react';


export const SlickArrowLeft = ({ currentSlide = 0, slideCount = 0, cn = '', ...props }) => (
    <button {...props} className={"slick-prev slick-arrow " + cn + (currentSlide === 0 ? " slick-disabled" : "")}
        aria-hidden="true"
        aria-disabled={currentSlide === 0 ? true : false}
        type="button" ></button>);

export const SlickArrowRight = ({ currentSlide = 0, slideCount = 0, cn = '', ...props }) => (
    <button {...props}
        className={"slick-next slick-arrow " + cn + (currentSlide === slideCount - 1 ? " slick-disabled" : "")}
        aria-hidden="true"
        aria-disabled={currentSlide === slideCount - 1 ? true : false}
        type="button"></button>);



export const SlickProps = {
    slide: '.slide_item',
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    speed: 400,
    arrows: true,
    dots: true,
    dotsClass: 'slide_dots _blue',
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    prevArrow: <SlickArrowLeft cn="prev_btn _blue" />,
    nextArrow: <SlickArrowRight cn="next_btn _blue" />,
    cssEase: 'ease-in-out',
    adaptiveHeight: false,
    responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 4 } },
        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        // { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ]
};